import { Box, BoxProps, ColorOptions, Spacer, Text, TextProps } from '@jfs/ui-new'
import { useStores } from '../../../data/store'
import { getFormattedAmount } from '../../../util/utill'
import { REFUND_STRINGS } from '../RefundStrings'

interface NamedValueProps {
  title: string
  value: string
  valueColor?: ColorOptions
}

export const NamedValue = ({ title, value, valueColor = 'BRAND_COLOR_GRAY_1' }: NamedValueProps) => {
  return (
    <Box {...styles.nameValueContainer}>
      <Text {...styles.lessDense} title={title} />
      <Spacer size={4} />
      <Text {...styles.normalText} title={value} color={valueColor} />
    </Box>
  )
}

export const voucherStatusColors: any = {
  ACTIVE: 'AVAILABLE_GREEN' as ColorOptions,
  REDEEM_IN_PROGRESS: 'YELLOW' as ColorOptions,
  REDEEMED: 'BRAND_PRIMARY_RED' as ColorOptions,
}

export const RefundDetailComponent = () => {
  const { customerName, refundAmount, voucherStatus } = useStores((root) => ({
    customerName: root.refundCode.getCustomerName(),
    refundAmount: root.refundCode.voucherDetails.voucherAmount,
    voucherStatus: root.refundCode.voucherDetails.voucherStatus,
  }))

  return (
    <Box {...styles.renderedItem}>
      <NamedValue title={REFUND_STRINGS.customerName} value={customerName} />
      <NamedValue title={REFUND_STRINGS.refundAmt} value={getFormattedAmount(refundAmount)} />
      <NamedValue title={REFUND_STRINGS.trnxType} value={'Domestic Money Transfer'} />
      <NamedValue
        title={REFUND_STRINGS.voucherStatus}
        value={voucherStatus}
        valueColor={voucherStatusColors[voucherStatus]}
      />
    </Box>
  )
}

const styles = {
  lessDense: {
    color: 'BRAND_COLOR_GRAY_2',
    fontSize: 12,
    fontFamily: 'jioType-medium',
  } as TextProps,
  normalText: {
    color: 'BRAND_COLOR_GRAY_1',
    fontSize: 14,
    fontFamily: 'jioType-medium',
  } as TextProps,
  nameValueContainer: {
    width: '47%',
    paddingBottom: 24,
  } as BoxProps,
  renderedItem: {
    flexDirection: 'row',
    width: '100%',
    justify: 'space-between',
    flexWrap: 'wrap',
  } as BoxProps,
}
